import { getAppEnv, getEnvTypeForNumberedEnvs, getLocalStorageEnv, getUrlEnv, get, replaceConfigEnvTemplate } from './helpers';

const config = ENV || {};

const localStorageEnv = getLocalStorageEnv();
const appEnv = getAppEnv();
let overrideDefaultEnv;
const defaultEnv = 'production';

let isGetEnvNameCalled = false;

export default function getConfig(path = null) {
  const envName = getEnvName();
  const configName = getConfEnvName();

  const decoratedConfig = replaceConfigEnvTemplate(envName, config[configName] || {});

  return path ? get(decoratedConfig, path) : decoratedConfig;
}

export function getConfEnvName() {
  const envName = getEnvName();
  return getEnvTypeForNumberedEnvs(envName) || envName;
}

function getEnvName() {
  isGetEnvNameCalled = true;
  return localStorageEnv || appEnv || overrideDefaultEnv || getUrlEnv() || defaultEnv;
}

export function setDefaultEnv(defaultEnv) {
  if (isGetEnvNameCalled) {
    console.error(
      'env-config',
      'You set the default environment after the environment was already called, your application may be in an inconsistent state!'
    );
  }
  if (appEnv) {
    console.warn('env-config', 'APP_ENV was set, default environment will be ignored');
  }
  overrideDefaultEnv = defaultEnv;
}
